import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UtilService } from '../../services/util.service';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  public projects: any = [];
  public user: any;
  public errorMessage: any;
  public successMessage: any;
  public name: string;
  public description: string;
  public activeProject: string;
  @Input() id!: string;
  fileName!: string;
  projectForm!: FormGroup;
  isUpdateMode: boolean = false; // Flag to indicate if it's update mode
  projectToUpdate: any;
  loading: boolean;
  protected currentPage = 1;
  protected search: string = '';
  protected limit: number = 10;
  protected imageUrl: string = '';
  constructor(
    private fb: FormBuilder,
    private util: UtilService,
    private localStorage: LocalStorageService,
    private commonService: CommonService,
    private api: ApiService,
    private toasterService: ToastrService,
    private projectService: ProjectService) { }

  ngOnInit(): void {
   initFlowbite();
   this.imageUrl= this.localStorage.get('profile_image')??'';
    this.loadProjects();
    this.projectForm = this.fb.group({
      name: ['', Validators.required],
      description: ['']
    });

    this.api.GET('user/me').subscribe({
      next: (response: any) => {
        this.user = response?.data?.user;
        this.localStorage.set('userData', this.user);
      }
    });
    this.commonService.updateSidebarObservable.subscribe({
      next: (updateStatus: boolean) => {
        if (updateStatus) {
          this.activeProject = this.localStorage.get('projectId')!;

        }
      }
    })


    this.activeProject = window.location.href.split('/')[window.location.href.split('/').length - 2];
  }



  submitForm(): void { }

  /**
   * Creates project
   */
  createProject(): void {
    this.loading = true;
    this.projectService.createProject(this.projectForm.value).subscribe({
      next: (response: any) => {
        this.successMessage = true;
        this.toasterService.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        this.projectForm.reset();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.errorMessage = error.error.message;
        console.log('error', error.error.message);

        this.loading = false;
      },
      complete: () => {
        window.location.reload();
        this.loading = false; // End loading
      }
    });
  }

  /**
   * Loads projects
   */
  loadProjects() {
    this.projectService.listProjects(this.currentPage, this.limit, this.search);
    this.projectService.projects$.subscribe({
      next: (projects: any[]) => {
        this.projects = projects;

      },
      error: (err: any) => {
        console.error('Error loading projects', err);
        this.errorMessage = 'Failed to load projects.';
      }
    });
  }

  /**
 * Determines whether search on
 * @param event
 */
  onSearch(event: any) {
    console.log('search');

    this.search = event.target.value.trim();
    console.log('this.search', this.search);

    this.loadProjects();
  }
}
